(() => {
  const desktopMenu = window.matchMedia('(min-width: 750px)');

  document.addEventListener('click', (event) => {
    if (!desktopMenu.matches || !(event.target instanceof Element)) return;
    if (event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

    const link = event.target.closest('header-menu .menu-list__link[aria-haspopup="true"]');
    if (!link) return;

    const menu = link.closest('header-menu');
    const item = link.closest('.menu-list__list-item');
    if (!item || typeof menu?.activate !== 'function') return;

    event.preventDefault();
    menu.activate({ target: item });
  });
})();
